
/* auth */
const authUserInfo = state => state.auth.userInfo
const needPrerequisite = state => state.auth.needPrerequisite
const authUserResource = state => state.auth.userResource
const authServiceGroups = state => state.auth.serviceGroups
const authPrerequisiteFlag = state => state.auth.prerequisites.length > 0
const authMessage = state => state.auth.message
const authPrerequisites = state => state.auth.prerequisites
const saveFrom = state => state.auth.from

/* Board */
const boardDocuments = state => state.board.boardDocuments
const boardDocument = state => state.board.boardDocument

/* Profile */
const logHistory = state => state.profile.logHistory
const userInfo = state => state.profile.userInfo

/* Document */
const agreementDocument = state => state.document.agreementDocument
const privacyDocument = state => state.document.privacyDocument

export default {
    /* auth */
    authUserInfo,
    needPrerequisite,
    authPrerequisiteFlag,
    authUserResource,
    authServiceGroups,
    authMessage,
    authPrerequisites,
    saveFrom,

    /* Board */
    boardDocuments,
    boardDocument,

    /* Profile */
    logHistory,
    userInfo,

    /* Document */
    agreementDocument,
    privacyDocument

}
